const getClasses = (
  ...args: (string | boolean | number | undefined | null)[]
) => args.filter((el) => el).join(" ");
export default getClasses;
